var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyPledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89233 28.7523L13.9894 36.315L34.3211 23.2081L22.8948 15.5588L2.89233 28.7523Z",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1781 17.7593L25.7103 17.9932C23.4753 19.4485 20.2094 17.9932 20.2094 17.9932C20.2094 17.9932 19.8109 17.7939 19.7329 17.6467",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1507 25.244C30.8486 24.9905 30.6064 24.6732 30.4416 24.315C30.2768 23.9567 30.1935 23.5663 30.1977 23.172C30.2018 22.7777 30.2933 22.3892 30.4656 22.0344C30.6379 21.6797 30.8866 21.3676 31.194 21.1205",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.105 34.3485C11.105 34.3485 13.3746 32.6159 17.169 34.2619",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02832 26.7079C6.02832 26.7079 8.34996 28.9863 6.02832 30.8661",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43335 31.1693L14.1369 38.7493L34.6158 25.5384",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43335 33.569L14.1369 41.0104L34.5812 27.8948",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43335 35.9859L14.1369 43.5399L34.5812 30.2598",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6565 23.4074L22.4444 28.5878",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4162 23.5633C18.4162 23.5633 14.7692 23.3727 14.7605 25.1746C14.7519 26.9765 17.7579 26.3527 18.4162 26.0409C19.4558 25.5904 22.5831 24.5682 22.2452 27.2537C21.994 28.5444 18.936 28.4058 18.936 28.4058",
    stroke: "#FF8B4D",
    strokeWidth: 0.866285,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0949 11.5219L43.7634 7.19048C43.715 7.14071 43.6571 7.10115 43.5931 7.07413C43.5291 7.04712 43.4604 7.0332 43.3909 7.0332C43.3215 7.0332 43.2527 7.04712 43.1888 7.07413C43.1248 7.10115 43.0669 7.14071 43.0184 7.19048L38.687 11.5219C38.6372 11.5703 38.5977 11.6283 38.5707 11.6922C38.5437 11.7562 38.5297 11.825 38.5297 11.8944C38.5297 11.9639 38.5437 12.0326 38.5707 12.0966C38.5977 12.1606 38.6372 12.2185 38.687 12.2669L39.0595 12.6307C39.1072 12.6803 39.1644 12.7197 39.2276 12.7466C39.2909 12.7735 39.3589 12.7873 39.4277 12.7873C39.4964 12.7873 39.5645 12.7735 39.6277 12.7466C39.691 12.7197 39.7482 12.6803 39.7959 12.6307L42.6373 9.79799V27.7907H38.0806C37.9409 27.7923 37.8073 27.8482 37.7081 27.9467L37.2143 28.5011C37.1482 28.5749 37.1046 28.6661 37.0886 28.7639C37.0726 28.8617 37.0849 28.9621 37.1241 29.0531C37.1632 29.1442 37.2276 29.2221 37.3096 29.2778C37.3916 29.3335 37.4878 29.3646 37.5868 29.3674H43.0964C43.3744 29.3674 43.641 29.2569 43.8376 29.0604C44.0342 28.8638 44.1446 28.5972 44.1446 28.3192V9.79799L46.9774 12.6307C47.0258 12.6805 47.0837 12.7201 47.1477 12.7471C47.2117 12.7741 47.2804 12.788 47.3499 12.788C47.4193 12.788 47.4881 12.7741 47.552 12.7471C47.616 12.7201 47.6739 12.6805 47.7224 12.6307L48.0949 12.2669C48.1446 12.2185 48.1842 12.1606 48.2112 12.0966C48.2382 12.0326 48.2521 11.9639 48.2521 11.8944C48.2521 11.825 48.2382 11.7562 48.2112 11.6922C48.1842 11.6283 48.1446 11.5703 48.0949 11.5219V11.5219Z",
    fill: "#FF8B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2509,
    height: 36.973,
    fill: "white",
    transform: "translate(2 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPledge);
export default __webpack_public_path__ + "static/media/Money Pledge.a3411c2704e8da4014cc08e4cad898bb.svg";
export { ForwardRef as ReactComponent };